import { useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import api from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const STATUSES = ["Draft", "Sent", "Viewed", "Accepted", "Payment Pending", "Paid", "Onboarding", "Active", "Completed", "Cancelled", "Lost"];

export default function AdminProposals() {
  const qc = useQueryClient();
  const { data: proposals = [] } = useQuery({ queryKey: ["admin-proposals"], queryFn: async () => (await api.get("/admin/proposals")).data, staleTime: 0, refetchOnMount: "always" });

  const setStatus = async (id, status) => {
    await api.put(`/admin/proposals/${id}`, { status });
    toast.success("Proposal updated");
    qc.invalidateQueries({ queryKey: ["admin-proposals"] });
  };

  return (
    <div>
      <h1 className="font-display text-2xl font-bold">Proposals</h1>
      <p className="text-sm text-muted-foreground">{proposals.length} proposals · quote → acceptance workflow</p>

      <div className="mt-6 overflow-hidden rounded-xl border border-border">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-secondary/50 text-left text-xs uppercase text-muted-foreground">
              <tr><th className="p-3">Proposal</th><th className="p-3">Client</th><th className="p-3">Package</th><th className="p-3">Total</th><th className="p-3">Status</th></tr>
            </thead>
            <tbody>
              {proposals.map((p) => (
                <tr key={p.id} className="border-t border-border" data-testid={`admin-proposal-${p.id}`}>
                  <td className="p-3"><a href={`/proposal/${p.id}`} target="_blank" rel="noreferrer" className="font-mono text-xs text-primary">{p.proposal_no}</a><div className="text-xs text-muted-foreground">{new Date(p.created_at).toLocaleDateString()}</div></td>
                  <td className="p-3"><div className="font-semibold">{p.name}</div><div className="text-xs text-muted-foreground">{p.email}</div></td>
                  <td className="p-3"><Badge variant="outline">{p.package_name}</Badge></td>
                  <td className="p-3 font-semibold">{p.currency} {Number(p.total).toLocaleString()}</td>
                  <td className="p-3">
                    <Select value={p.status} onValueChange={(v) => setStatus(p.id, v)}>
                      <SelectTrigger className="w-40" data-testid={`proposal-status-${p.id}`}><SelectValue /></SelectTrigger>
                      <SelectContent>{STATUSES.map((s) => <SelectItem key={s} value={s}>{s}</SelectItem>)}</SelectContent>
                    </Select>
                  </td>
                </tr>
              ))}
              {proposals.length === 0 && <tr><td colSpan={5} className="p-8 text-center text-muted-foreground">No proposals yet.</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
